import * as wwSdk from "@wecom/jssdk";
import { getConfigSignature } from "@/api/qwTools";
import { getSpreadInfo } from "@/api/activity/actList";

import { ElMessageBox } from "element-plus";
import useUserStore from "@/store/modules/user";
import { tryHideFullScreenLoading, showFullScreenLoading } from "@/utils/serviceLoading";

let wwRegisterStatus = 0;
const wxCodeUrlKey = "WxCodeUrl";
setUrl();

export function setUrl() {
  sessionStorage.setItem(wxCodeUrlKey, location.href);
}

export const wwRegister = () => {
  return new Promise((resolve, reject) => {
    // showFullScreenLoading();
    console.log(wwRegisterStatus);
    if (wwRegisterStatus == 1) {
      resolve();
      return;
    }

    if (location.href.includes("noAuth_qw")) {
      wwRegisterStatus = 1;
      resolve();
      return;
    }

    if (!isQw()) {
      ElMessageBox.alert("非企业微信环境，授权失败", { confirmButtonText: "确定", type: "warning", "show-close": false }).then(() => {
        // location.reload();
      });
      reject("非企业微信环境");
      return;
    }

    let url = window.location.href.split("#")[0];
    if (isIos()) {
      const wxCodeUrl = sessionStorage.getItem(wxCodeUrlKey);

      if (wxCodeUrl) {
        url = wxCodeUrl;
      }
    }

    getConfigSignature({
      url,
    })
      .then((res) => {
        if (res.code == 200) {
          const { agentId, corpId, configSignature, agentConfigSignature } = res.data;

          wwSdk.register({
            agentId,
            corpId,
            jsApiList: ["hideOptionMenu", "closeWindow", "sendChatMessage", "shareToExternalContact", "shareToExternalChat", "shareToExternalMoments", "openDefaultBrowser"],
            getConfigSignature() {
              return configSignature;
            },
            onConfigSuccess() {},
            onConfigFail() {
              console.log("onConfigFail");
            },
            getAgentConfigSignature() {
              return agentConfigSignature;
            },
            onAgentConfigSuccess() {
              console.log("onAgentConfigSuccess");
              // tryHideFullScreenLoading();
              wwRegisterStatus = 1;
              resolve();
            },
            onAgentConfigFail() {
              console.log("onAgentConfigFail");
              registerFailHandler();
              reject();
            },
          });
        } else {
          registerFailHandler();
          reject();
        }
      })
      .catch((e) => {
        console.log(e);
        registerFailHandler();
        reject();
      });
  });
};

export const registerFailHandler = () => {
  // tryHideFullScreenLoading();
  ElMessageBox.alert("授权失败", { confirmButtonText: "重新授权", type: "warning", "show-close": false }).then(() => {
    location.reload();
  });
};

export const isQw = () => {
  return /wxwork/i.test(window.navigator.userAgent.toLowerCase());
};

export const isIos = () => {
  return /iPhone|iPad|iPod/i.test(window.navigator.userAgent.toLowerCase());
};

export const isPc = () => {
  return !navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
};

export const ww = wwSdk;

export const msgTitleCreate = (materialInfo = {}) => {
  const { id, type, format, name, fromActivityName, channelName } = materialInfo;

  if (type == 1) {
    // 活动营销素材 直接取name
    return name;
  }

  return format == 2 ? fromActivityName : name;
};

export const msgImgUrlCreate = (materialInfo = {}) => {
  const { id, format, name, fromActivityName, channelName } = materialInfo;

  return "https://static.rhkj.com/renhe_fe/other/logo.png";
};

// 发送链接卡片数据构造
export const msgCreate = (materialInfo = {}, taskInfo = {}) => {
  const { id, format, name, fromActivityName, channelName } = materialInfo;
  const { taskId } = taskInfo;

  const title = msgTitleCreate(materialInfo);
  const desc = "点击查看";
  const imgUrl = msgImgUrlCreate(materialInfo);
  // 链接域名
  const linkHost =
    {
      centertest: "h5pre",
      centerpre: "h5pro",
      center: "h5",
    }[location.host.split(".")[0]] || "h5pre";
  // 发送人企微id
  const weComUserId = (useUserStore().userInfo.weComInfo || {}).weComUserId || "";
  // 渠道
  const source = encodeURIComponent(`yxgl${channelName}`);
  const link = `https://${linkHost}.rhkj.com/#/qwTools/index?${queryToString({ id, weComUserId, taskId, source })}`;

  const msgData = {
    link, // msgtype news
    url: link, // msgtype link
    title,
    desc,
    imgUrl,
  };

  console.log(msgData);
  return msgData;
};

export const msgImgUrlMiniCreate = (materialInfo = {}) => {
  const defaultCover = "https://static.rhkj.com/renhe_fe/other/share-111.png";
  const { id, format, name, fromActivityName, channelName, miniPosterCover, miniFromCover, miniVideoCover, miniArticleCover } = materialInfo;
  // 1 视频 2 文章 3 海报 4 表单 5 财税实训体验账号 6 课程内容库素材
  const config = {
    1: miniVideoCover,
    2: miniArticleCover,
    3: miniPosterCover,
    4: miniFromCover,
    5: miniPosterCover,
    6: miniVideoCover,
  };

  return config[format] || defaultCover;
};

// 发送小程序卡片数据构造
export const msgMiniCreate = (materialInfo = {}, taskInfo = {}) => {
  const { id, format, name, fromActivityName, channelName } = materialInfo;
  const { taskId } = taskInfo;

  const appid = "wxf965a9dd5b813a99";
  const title = msgTitleCreate(materialInfo);
  const imgUrl = msgImgUrlMiniCreate(materialInfo);

  // 发送人企微id
  const weComUserId = (useUserStore().userInfo.weComInfo || {}).weComUserId || "";
  // 渠道
  const source = encodeURIComponent(`yxgl${channelName}`);
  const page = `pages/qwTools/index.html?${queryToString({ id, weComUserId, taskId, source })}`;
  const pageMini = `pages/qwTools/index?${queryToString({ id, weComUserId, taskId, source })}`;

  const msgData = {
    appid,
    title,
    imgUrl,
    page,
  };

  console.log(msgData);
  console.log("-----------小程序页面路径-----------", pageMini);
  return msgData;
};

// 获取体验版二维码
export const previewTrialQrcode = async (materialInfo = {}, taskInfo = {}) => {
  const { id, format, name, fromActivityName, channelName } = materialInfo;
  const { taskId } = taskInfo;

  const appid = "wxf965a9dd5b813a99";

  // 发送人企微id
  const weComUserId = (useUserStore().userInfo.weComInfo || {}).weComUserId || "";
  // 渠道
  const source = encodeURIComponent(`yxgl${channelName}`);

  const res = await getSpreadInfo({
    page: "pages/qwTools/index",
    scene: queryToString({ id, weComUserId, taskId, source }),
    envVersion: "trial",
  });

  ElMessageBox({
    message: h("img", { src: res.data.buffer, style: { width: "100%" } }),
  });
};

export const queryToString = (query = {}) => {
  const queryArr = [];

  for (let [key, value] of Object.entries(query)) {
    if (value) {
      queryArr.push(`${key}=${value}`);
    }
  }

  return queryArr.join("&");
};
